var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row text-center",attrs:{"id":"newBanner"}},[_c('div',{staticClass:"col-md-12 d-flex mx-0"},[_c('b-carousel',{staticClass:"w-100",attrs:{"id":"carousel","interval":10000,"controls":""}},_vm._l((_vm.banners),function(i){return _c('b-carousel-slide',{key:i.id,attrs:{"img-src":i.url_file,"img-alt":i.alt_name}})}),1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }